import { render, staticRenderFns } from "./GoodsHall.vue?vue&type=template&id=50897936&scoped=true"
import script from "./GoodsHall.vue?vue&type=script&lang=js"
export * from "./GoodsHall.vue?vue&type=script&lang=js"
import style0 from "./GoodsHall.vue?vue&type=style&index=0&id=50897936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50897936",
  null
  
)

export default component.exports